import { render, staticRenderFns } from "./PopupBody.vue?vue&type=template&id=c4556bfc&scoped=true"
import script from "./PopupBody.vue?vue&type=script&lang=js"
export * from "./PopupBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4556bfc",
  null
  
)

export default component.exports